export const DEFAULT_FORM_DATA = {
  name: '',
  overview: ``,
  entities: [],
  programs: [],
  weekStages: [],
  maxIdInPlan: 0,
  totalDay: 0,
  unit: 1,
  sourceId: '',
  sourceUrl: '',
  minWeeks: 0,
  maxWeeks: 0,
  region: 1,
  pbVersion: 2,
  versionObjects: [],
  exercises: [],
  sportType: 1
};
// 训练计划提交表单
export const DEFAULT_PLAN_FORM = {
  name: 'N1117',
  programs: [],
  entities: [],
  versionObjects: []
};
